import { getPlaybookPerspective } from "./playbook";
import { getStaffSession } from "./staffSession";

export function prepareApiHeaders(headers: Headers): Headers {
  const cookies = decodeURIComponent(document.cookie).split(";");
  const cookie = cookies.find((c) => c.trim().startsWith("csrftoken"));
  if (cookie) {
    headers.set("X-CSRFToken", cookie.split("=")[1]);
  }
  const staffSession = getStaffSession();
  if (staffSession) {
    headers.set("X-Staff-Session", staffSession.uuid);
  }
  const playbookPreview = getPlaybookPerspective();
  if (playbookPreview && playbookPreview !== "published") {
    headers.set("X-Playbook-Perspective", playbookPreview);
  }
  return headers;
}
